import {
  RequestModel,
  RequestResponseModel,
} from "../../../request/domain/models/requestModel";
import { CarModel } from "../../domain/models/carModel";
import { CarTireSetResponseModel } from "../../domain/models/carTireSetModel";

export class CarTireSetResponseService {
  static convertToRequest(request: RequestResponseModel): RequestModel {
    return {
      id: request.id,
      type: request.type,
      state: request.state,
      pickupAndDeliveryDate: request.pickup_and_delivery_date,
      inOutStorage: request.in_out_storage,
      sourceType: request.source_type,
      sourceId: request.source_id,
      invoiceStatus: request.invoice_status,
      invoiced: request.invoiced,
      workOrderNumber: request.work_order_number,
      createdAt: request.created_at,
      availableTransitions: request.availableTransitions,
      relationId: request.relation?.id,
      relation: request.relation,
      userId: request.user?.id,
      stateFlow: request.stateFlow,
      shippingListId: request.shipping_list_id?.id,
      requestTires: request.requestTires,
    };
  }

  public static convertToCarModel(
    car: CarModel,
    tireSets?: CarTireSetResponseModel[],
  ): CarModel {
    return {
      ...car,
      tireSets:
        tireSets?.map((t) => ({
          id: t.id,
          type: t.type,
          sleepingSet: t.sleep_set,
          inHotel: t.in_hotel,
          tire_rim: t.tire_rim,
          position_id: t.position?.id,
          comment: t.comment,
          requests: t.requests?.map((request) =>
            CarTireSetResponseService.convertToRequest(request),
          ),
          activeRequests: t.activeRequests?.map((request) =>
            CarTireSetResponseService.convertToRequest(request),
          ),
          storedLatestRequest: t.storedLatestRequest
            ? CarTireSetResponseService.convertToRequest(t.storedLatestRequest)
            : undefined,
          sticker: t.sticker,
          tires: t.tires?.map((tire) => ({
            id: tire.id,
            brand: tire.brand,
            brandType: tire.brand_type,
            type: tire.type,
            ean: tire.ean,
            profile: tire.profile_depth,
            car_position: tire.car_position,
            size: tire.size,
            run_flat: tire.run_flat,
            status: tire.status,
          })),
          car_id: t.car?.id,
        })) || [],
    };
  }
}
